<span>
  {@html companyInformation}
</span>

<style lang="less">
  @import (less) '@spotify-internal/encore-foundation/web/tokens.css';
  @import (reference) '../../../less/variables';
  @import (reference) '../../../less/mixins';
  span {
    margin: 16px 0;
    .footer-text-small();
    color: @masthead-gray-50;

    :global(a) {
      color: @masthead-gray-50;

      &:hover {
        color: var(--spotify-green-157);
      }
    }
  }
</style>

<script>
  export let companyInformation;
</script>
